module.exports = __webpack_public_path__ + "static/img/sc9.efc229d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc9.png
// module id = 9Skd
// module chunks = 25